module.exports = "/_next/static/images/bc596fcd63ae0c23150501ce285bff0f-phone-and-card@3x.png";